import api from "../../api";
import { formatArrayToElSelect } from "../../utils";

const state = {
  status: "",
  technicians: []
};

const getters = {
  getTechniciansSelector: (state) => {
    return formatArrayToElSelect(state.technicians, {
      label: "FullName",
      value: "Id"
    });
  },
  getTechnicianById: (state) => (id) => {
    return state.technicians.find((f) => f.Id === id);
  }
};

const actions = {
  fetchTechnicians: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .get("/api/users/technicians")
        .then((resp) => {
          commit("success");
          commit("SET_TECHNICIANS", resp.data);
          resolve(resp.data);
        })
        .catch((error) => {
          commit("error");
          reject(error);
        });
    });
  }
};

const mutations = {
  loading: (state) => (state.status = "loading"),
  success: (state) => (state.status = "success"),
  error: (state) => (state.status = "error"),
  SET_TECHNICIANS: (state, payload) => {
    state.technicians = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
